import { forwardRef } from "react";
import { BsCheck } from "react-icons/bs";

import type { ICheckboxProps } from "./ICheckboxProps";

const component: React.ForwardRefRenderFunction<
	HTMLInputElement,
	ICheckboxProps
> = ({ label, error = false, ...props }, ref) => {
	return (
		<label className="flex grow-0 gap-3 cursor-pointer">
			<div
				data-error={error}
				className="relative z-0 flex shrink-0 w-[25px] h-[25px] border-2
          rounded-md data-[error=true]:border-gpa-red border-gpa-blue-500
          bg-white"
			>
				<input
					{...props}
					ref={ref}
					type="checkbox"
					className="peer opacity-0 bg-transparent focus:bg-transparent"
				/>
				<div
					data-error={error}
					className="absolute h-full w-full peer-checked:block hidden
            bg-gpa-blue-500  data-[error=true]:bg-gpa-red"
				>
					<BsCheck className="text-white w-full h-full" />
				</div>
			</div>
			<span data-error={error} className="z-0 data-[error=true]:text-gpa-red">
				{label}
			</span>
		</label>
	);
};

export const Checkbox = forwardRef(component);
